import { testId } from '../../utils';
import { Iconography } from '../primitives';

export interface FormErrorProps {
  children: React.ReactNode;
  'data-testid': string;
}

export const FormError: React.FC<FormErrorProps> = ({
  children,
  'data-testid': dataTestId,
}) => {
  return (
    <div
      {...testId(dataTestId)}
      className="text-xs font-medium text-red-dark flex gap-1 items-center"
      role="alert"
    >
      <Iconography variant="error" className="text-base" />
      <span>{children}</span>
    </div>
  );
};
